var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-header',{staticClass:"pb-5"},[_c('b-row',{staticClass:"py-0 px-0",attrs:{"align-v":"center"}})],1),_c('b-container',{staticClass:"mt--5",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"order-xl-1 offset-xl-0",attrs:{"xl":"12"}},[_c('card',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }